'use client';
"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _chunkFRYXK4GHjs = require('./chunk-FRYXK4GH.js');


var _chunkO2LDUJ2Wjs = require('./chunk-O2LDUJ2W.js');


var _chunkPITTAPGTjs = require('./chunk-PITTAPGT.js');


var _chunkZKSQPXAKjs = require('./chunk-ZKSQPXAK.js');


var _chunkD7W5LS72js = require('./chunk-D7W5LS72.js');
require('./chunk-HPS6KITB.js');
require('./chunk-V4ZCTWTO.js');
require('./chunk-T7MXYC4U.js');
require('./chunk-U3YBTIJK.js');


var _chunkJALX2CO3js = require('./chunk-JALX2CO3.js');
require('./chunk-KEVJNU3Q.js');

// src/toast/Toast.tsx
var _reacttoastify = require('react-toastify');

// src/toast/styles.ts
var _styledcomponents = require('styled-components'); var _styledcomponents2 = _interopRequireDefault(_styledcomponents);
var Toastify__bounceInRight = _styledcomponents.keyframes`
            from,
            60%,
            75%,
            90%,
            to {
                animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            }
            from {
                opacity: 0;
                transform: translate3d(3000px, 0, 0);
            }
            60% {
                opacity: 1;
                transform: translate3d(-25px, 0, 0);
            }
            75% {
                transform: translate3d(10px, 0, 0);
            }
            90% {
                transform: translate3d(-5px, 0, 0);
            }
            to {
                transform: none;
            }
        `;
var Toastify__bounceOutRight = _styledcomponents.keyframes`
            20% {
                opacity: 1;
                transform: translate3d(-20px, 0, 0);
            }
            to {
                opacity: 0;
                transform: translate3d(2000px, 0, 0);
            }
        `;
var Toastify__bounceInLeft = _styledcomponents.keyframes`
            from,
            60%,
            75%,
            90%,
            to {
                animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            }
            0% {
                opacity: 0;
                transform: translate3d(-3000px, 0, 0);
            }
            60% {
                opacity: 1;
                transform: translate3d(25px, 0, 0);
            }
            75% {
                transform: translate3d(-10px, 0, 0);
            }
            90% {
                transform: translate3d(5px, 0, 0);
            }
            to {
                transform: none;
            }
        `;
var Toastify__bounceOutLeft = _styledcomponents.keyframes`
            20% {
                opacity: 1;
                transform: translate3d(20px, 0, 0);
            }
            to {
                opacity: 0;
                transform: translate3d(-2000px, 0, 0);
            }
        `;
var Toastify__bounceInUp = _styledcomponents.keyframes`
            from,
            60%,
            75%,
            90%,
            to {
                animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            }
            from {
                opacity: 0;
                transform: translate3d(0, 3000px, 0);
            }
            60% {
                opacity: 1;
                transform: translate3d(0, -20px, 0);
            }
            75% {
                transform: translate3d(0, 10px, 0);
            }
            90% {
                transform: translate3d(0, -5px, 0);
            }
            to {
                transform: translate3d(0, 0, 0);
            }
        `;
var Toastify__bounceOutUp = _styledcomponents.keyframes`
            20% {
                transform: translate3d(0, -10px, 0);
            }
            40%,
            45% {
                opacity: 1;
                transform: translate3d(0, 20px, 0);
            }
            to {
                opacity: 0;
                transform: translate3d(0, -2000px, 0);
            }
        `;
var Toastify__bounceInDown = _styledcomponents.keyframes`
            from,
            60%,
            75%,
            90%,
            to {
                animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            }
            0% {
                opacity: 0;
                transform: translate3d(0, -3000px, 0);
            }
            60% {
                opacity: 1;
                transform: translate3d(0, 25px, 0);
            }
            75% {
                transform: translate3d(0, -10px, 0);
            }
            90% {
                transform: translate3d(0, 5px, 0);
            }
            to {
                transform: none;
            }
        `;
var Toastify__bounceOutDown = _styledcomponents.keyframes`
            20% {
                transform: translate3d(0, 10px, 0);
            }
            40%,
            45% {
                opacity: 1;
                transform: translate3d(0, -20px, 0);
            }
            to {
                opacity: 0;
                transform: translate3d(0, 2000px, 0);
            }
        `;
var Toastify__zoomIn = _styledcomponents.keyframes`
            from {
                opacity: 0;
                transform: scale3d(0.3, 0.3, 0.3);
            }
            50% {
                opacity: 1;
            }
        `;
var Toastify__zoomOut = _styledcomponents.keyframes`
            from {
                opacity: 1;
            }
            50% {
                opacity: 0;
                transform: scale3d(0.3, 0.3, 0.3);
            }
            to {
                opacity: 0;
            }
        `;
var Toastify__flipIn = _styledcomponents.keyframes`
            from {
                transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
                animation-timing-function: ease-in;
                opacity: 0;
            }
            40% {
                transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
                animation-timing-function: ease-in;
            }
            60% {
                transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
                opacity: 1;
            }
            80% {
                transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
            }
            to {
                transform: perspective(400px);
            }
        `;
var Toastify__flipOut = _styledcomponents.keyframes`
            from {
                transform: perspective(400px);
            }
            30% {
                transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
                opacity: 1;
            }
            to {
                transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
                opacity: 0;
            }
        `;
var Toastify__slideInRight = _styledcomponents.keyframes`
            from {
                transform: translate3d(110%, 0, 0);
                visibility: visible;
            }
            to {
                transform: translate3d(0, 0, 0);
            }
        `;
var Toastify__slideInLeft = _styledcomponents.keyframes`
            from {
                transform: translate3d(-110%, 0, 0);
                visibility: visible;
            }
            to {
                transform: translate3d(0, 0, 0);
            }
        `;
var Toastify__slideInUp = _styledcomponents.keyframes`
            from {
                transform: translate3d(0, 110%, 0);
                visibility: visible;
            }
            to {
                transform: translate3d(0, 0, 0);
            }
        `;
var Toastify__slideInDown = _styledcomponents.keyframes`
            from {
                transform: translate3d(0, -110%, 0);
                visibility: visible;
            }
            to {
                transform: translate3d(0, 0, 0);
            }
        `;
var Toastify__slideOutRight = _styledcomponents.keyframes`
            from {
                transform: translate3d(0, 0, 0);
            }
            to {
                visibility: hidden;
                transform: translate3d(110%, 0, 0);
            }
        `;
var Toastify__slideOutLeft = _styledcomponents.keyframes`
            from {
                transform: translate3d(0, 0, 0);
            }
            to {
                visibility: hidden;
                transform: translate3d(-110%, 0, 0);
            }
        `;
var Toastify__slideOutDown = _styledcomponents.keyframes`
            from {
                transform: translate3d(0, 0, 0);
            }
            to {
                visibility: hidden;
                transform: translate3d(0, 500px, 0);
            }
        `;
var Toastify__slideOutUp = _styledcomponents.keyframes`
            from {
                transform: translate3d(0, 0, 0);
            }
            to {
                visibility: hidden;
                transform: translate3d(0, -500px, 0);
            }
        `;
var Toastify__spin = _styledcomponents.keyframes`
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);
            }
        `;
var necessaryToastStyles = _styledcomponents.css`
    z-index: var(--toastify-z-index);
    transform: translate3d(0, 0, var(--toastify-z-index));
    position: fixed;
    padding: 4px;
    width: var(--toastify-toast-width);

    &.Toastify__toast-container--top-left {
        top: 1em;
        left: 1em;
    }
    &.Toastify__toast-container--top-center {
        top: 1em;
        left: 50%;
        transform: translateX(-50%);
    }
    &.Toastify__toast-container--top-right {
        top: 1em;
        right: 1em;
    }
    &.Toastify__toast-container--bottom-left {
        bottom: 1em;
        left: 1em;
    }
    &.Toastify__toast-container--bottom-center {
        bottom: 1em;
        left: 50%;
        transform: translateX(-50%);
    }
    &.Toastify__toast-container--bottom-right {
        bottom: 1em;
        right: 1em;
    }

    @media only screen and (max-width: 480px) {
        &.Toastify__toast-container {
            width: 100vw;
            padding: 0;
            left: 0;
            margin: 0;
        }
        &.Toastify__toast-container--top-left,
        &.Toastify__toast-container--top-center,
        &.Toastify__toast-container--top-right {
            top: 0;
            transform: translateX(0);
        }
        &.Toastify__toast-container--bottom-left,
        &.Toastify__toast-container--bottom-center,
        &.Toastify__toast-container--bottom-right {
            bottom: 0;
            transform: translateX(0);
        }
    }
    .Toastify__toast--close-on-click {
        cursor: pointer;
    }
    .Toastify__toast-body > div:last-child {
        word-break: break-word;
        flex: 1;
    }

    .Toastify--animate {
        animation-fill-mode: both;
        animation-duration: 0.7s;
    }

    .Toastify--animate-icon {
        animation-fill-mode: both;
        animation-duration: 0.3s;
    }

    @media only screen and (max-width: 480px) {
        .Toastify__toast {
            margin-bottom: 0;
        }
    }

    .Toastify__close-button {
        color: #fff;
        background: transparent;
        outline: none;
        border: none;
        padding: 0;
        cursor: pointer;
        opacity: 0.7;
        transition: 0.3s ease;
        align-self: flex-start;
    }
    .Toastify__close-button--light {
        color: #000;
        opacity: 0.3;
    }
    .Toastify__close-button > svg {
        fill: currentColor;
        height: 16px;
        width: 14px;
    }
    .Toastify__close-button:hover,
    .Toastify__close-button:focus {
        opacity: 1;
    }

    .Toastify__spinner {
        width: 20px;
        height: 20px;
        box-sizing: border-box;
        border: 2px solid;
        border-radius: 100%;
        border-color: var(--toastify-spinner-color-empty-area);
        border-right-color: var(--toastify-spinner-color);
        animation: ${Toastify__spin} 0.65s linear infinite;
    }

    .Toastify__bounce-enter--top-left,
    .Toastify__bounce-enter--bottom-left {
        animation-name: ${Toastify__bounceInLeft};
    }
    .Toastify__bounce-enter--top-right,
    .Toastify__bounce-enter--bottom-right {
        animation-name: ${Toastify__bounceInRight};
    }
    .Toastify__bounce-enter--top-center {
        animation-name: ${Toastify__bounceInDown};
    }
    .Toastify__bounce-enter--bottom-center {
        animation-name: ${Toastify__bounceInUp};
    }

    .Toastify__bounce-exit--top-left,
    .Toastify__bounce-exit--bottom-left {
        animation-name: ${Toastify__bounceOutLeft};
    }
    .Toastify__bounce-exit--top-right,
    .Toastify__bounce-exit--bottom-right {
        animation-name: ${Toastify__bounceOutRight};
    }
    .Toastify__bounce-exit--top-center {
        animation-name: ${Toastify__bounceOutUp};
    }
    .Toastify__bounce-exit--bottom-center {
        animation-name: ${Toastify__bounceOutDown};
    }

    .Toastify__zoom-enter {
        animation-name: ${Toastify__zoomIn};
    }

    .Toastify__zoom-exit {
        animation-name: ${Toastify__zoomOut};
    }

    .Toastify__flip-enter {
        animation-name: ${Toastify__flipIn};
    }

    .Toastify__flip-exit {
        animation-name: ${Toastify__flipOut};
    }

    .Toastify__slide-enter--top-left,
    .Toastify__slide-enter--bottom-left {
        animation-name: ${Toastify__slideInLeft};
    }
    .Toastify__slide-enter--top-right,
    .Toastify__slide-enter--bottom-right {
        animation-name: ${Toastify__slideInRight};
    }
    .Toastify__slide-enter--top-center {
        animation-name: ${Toastify__slideInDown};
    }
    .Toastify__slide-enter--bottom-center {
        animation-name: ${Toastify__slideInUp};
    }

    .Toastify__slide-exit--top-left,
    .Toastify__slide-exit--bottom-left {
        animation-name: ${Toastify__slideOutLeft};
    }
    .Toastify__slide-exit--top-right,
    .Toastify__slide-exit--bottom-right {
        animation-name: ${Toastify__slideOutRight};
    }
    .Toastify__slide-exit--top-center {
        animation-name: ${Toastify__slideOutUp};
    }
    .Toastify__slide-exit--bottom-center {
        animation-name: ${Toastify__slideOutDown};
    }
`;

// src/toast/Toast.tsx

var _jsxruntime = require('react/jsx-runtime');
var CloseButton = ({ closeToast }) => {
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, UnstyledButton, { onClick: closeToast, children: /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _chunkD7W5LS72js.CloseIconMedium, { color: "default" }) });
};
var UnstyledButton = _styledcomponents2.default.button`
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
    margin: 0;
    padding: 0;
    height: min-content;
    margin-left: 16px;
`;
var ToastContainer = _styledcomponents2.default.call(void 0, _reacttoastify.ToastContainer).attrs(
  () => ({
    autoClose: 5e3,
    closeButton: CloseButton,
    hideProgressBar: true
  })
)`
    ${({ theme }) => _styledcomponents.css`
        --toastify-toast-width: 320px;
        --toastify-toast-min-height: 64px;
        --toastify-toast-max-height: 800px;
        --toastify-z-index: 9999;
        --toastify-toast-width: 384px;
        ${_chunkFRYXK4GHjs.smallerScreenThan.call(void 0, 
  "xs",
  _styledcomponents.css`
                --toastify-toast-width: 343px;
            `
)}

        ${necessaryToastStyles}

        .Toastify__toast {
            position: relative;
            min-height: var(--toastify-toast-min-height);
            box-sizing: border-box;
            margin-bottom: 1rem;
            padding: 8px;
            box-shadow:
                0 1px 10px 0 rgba(0, 0, 0, 0.1),
                0 2px 15px 0 rgba(0, 0, 0, 0.05);
            display: -ms-flexbox;
            display: flex;
            justify-content: space-between;
            max-height: var(--toastify-toast-max-height);
            overflow: hidden;
            cursor: default;
            direction: ltr;
            /* webkit only issue #791 */
            z-index: 0;
            /* styles above are from the package */

            padding: 16px 16px 16px 12px;
            border-left-width: 4px;
            border-left-style: solid;
            box-shadow: ${theme.elevation["03"]};
            border-radius: ${theme.input.border.radius};
        }
        .Toastify__toast-body {
            margin: auto 0;
            flex: 1 1 auto;
            display: -ms-flexbox;
            display: flex;
            align-items: center;
            /* styles above are from the package */

            padding: 0;
        }
        .Toastify__toast-icon {
            margin-inline-end: 10px;
            width: 20px;
            flex-shrink: 0;
            display: flex;
            /* styles above are from the package */

            align-self: flex-start;
        }
        .Toastify__toast--info {
            border-left-color: ${theme.color.border.info};
            background-color: ${theme.color.background.info.light};
        }
        .Toastify__toast--success {
            border-left-color: ${theme.color.border.success};
            background-color: ${theme.color.background.success.light};
        }
        .Toastify__toast--warning {
            border-left-color: ${theme.color.border.warning};
            background-color: ${theme.color.background.warning.light};
        }
        .Toastify__toast--error {
            border-left-color: ${theme.color.border.critical};
            background-color: ${theme.color.background.critical.light};
        }
    `}
`;
var toast = (role, {
  description,
  title
}, opts) => {
  const finalOpts = { ...opts, icon: /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _jsxruntime.Fragment, { children: getIcon(role) }) };
  const content = /* @__PURE__ */ _jsxruntime.jsxs.call(void 0, 
    Content,
    {
      $addPaddingTop: Boolean(title),
      "data-hui-id": "Toast",
      children: [
        title && /* @__PURE__ */ _jsxruntime.jsx.call(void 0, "span", { className: "hui-text-h5 text-text-primary", children: title }),
        description && /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _chunkJALX2CO3js.BodyPrimary, { children: description })
      ]
    }
  );
  switch (role) {
    case "info":
      _reacttoastify.toast.info(content, finalOpts);
      break;
    case "success":
      _reacttoastify.toast.success(content, finalOpts);
      break;
    case "warning":
      _reacttoastify.toast.warning(content, finalOpts);
      break;
    case "error":
      _reacttoastify.toast.error(content, finalOpts);
      break;
    default:
      throw new Error(`Unknown role for toast: ${role}`);
  }
};
var getIcon = (role) => {
  switch (role) {
    case "info":
      return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _chunkZKSQPXAKjs.InfoFilledIconMedium, { color: "info" });
    case "success":
      return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _chunkPITTAPGTjs.StatusIconMedium, { color: "success" });
    case "warning":
      return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _chunkO2LDUJ2Wjs.WarningIconMedium, { color: "warning.light" });
    case "error":
      return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _chunkO2LDUJ2Wjs.WarningIconMedium, { color: "critical" });
    default:
      return null;
  }
};
var Content = _styledcomponents2.default.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-left: 16px;
    padding-top: ${({ $addPaddingTop }) => $addPaddingTop ? "3px" : 0};
`;



exports.ToastContainer = ToastContainer; exports.toast = toast;
//# sourceMappingURL=data:application/json;base64,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